import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
const GROUP_TYPES = {
  default: {
    title: Text.BodySmall,
    titleColor: Colors.gray500,
    label: Text.BodySmall,
    labelColor: Colors.purple400
  },
  empty: {
    title: Text.BodyExtraSmall,
    titleColor: Colors.gray400
  }
};
const StyledText = styled.View`
  max-width: ${props => props.width};
`;
const StyledContainer = styled.View`
  align-items: center;
  justify-content: center;
  height: ${props => props.type === 'empty' && '18px'};
`;
const styles = {
  centerText: {
    textAlign: 'center'
  },
  emptyText: {
    opacity: 0.5
  }
};
export default function PageEnd(props) {
  const groupType = GROUP_TYPES[props.type];
  const TitleText = groupType.title;
  const LabelText = groupType.label;
  return /*#__PURE__*/React.createElement(StyledContainer, {
    type: props.type
  }, /*#__PURE__*/React.createElement(StyledText, {
    width: props.width
  }, /*#__PURE__*/React.createElement(TitleText, {
    color: groupType.titleColor,
    style: [styles.centerText, props.type === 'empty' && styles.emptyText]
  }, props.title, LabelText && /*#__PURE__*/React.createElement(LabelText, {
    color: groupType.labelColor,
    weight: "medium"
  }, ' ', props.label))), props.type === 'default' && /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }));
}
PageEnd.propTypes = {
  type: PropTypes.oneOf(Object.keys(GROUP_TYPES)),
  title: PropTypes.string,
  label: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
PageEnd.defaultProps = {
  type: 'default',
  title: '',
  label: '',
  width: '100%'
};
//# sourceMappingURL=index.js.map